import { render, staticRenderFns } from "./UniversityUnits.vue?vue&type=template&id=e374fdd0"
import script from "./UniversityUnits.vue?vue&type=script&lang=js"
export * from "./UniversityUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports